import { render } from "./MenuItems.vue?vue&type=template&id=c1b107aa"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__